import { FolderEntryFragmentFragment } from 'gql/index';

export const getFolderEntryName = (entry?: FolderEntryFragmentFragment | null) =>
  entry?.document?.fileName ?? entry?.externalLink?.name;